<template>
    <PopupRouterView :showLeftIcon="true" label="Dies Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="dies"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="diesInput">


        <b-card header="Dies" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"   />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   />
						<app-input-textbox id="fieldset-dies-long" label-cols-lg="12"  label="Long" label-for="input-dies-long" size="sm" :model.sync="model.diesLong"   />
						<app-input-textbox id="fieldset-wide" label-cols-lg="12"  label="Wide" label-for="input-wide" size="sm" :model.sync="model.wide"   />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-height" label-cols-lg="12"  label="Height" label-for="input-height" size="sm" :model.sync="model.height"   />
						<app-input-textbox id="fieldset-standar-preventive" label-cols-lg="12"  label="Standard Preventive (Total Stroke)" label-for="input-standar-preventive" size="sm" :model.sync="model.standarPreventive"   />
						<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Uom" id="fieldset-uom" size="sm" :model.sync="model.uomId" :isRequired="true" :state="validateState('uomId')" :errorMessage="getErrorMessage(errorMessage.uomId, 'uomId')"   :selected="model.uom != null ? model.uom.code : ''" @input="getUoms"   :isSelectMethodExists="true" @onSelectMethod="setSelectedUom" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"   />
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Dies from '@/models/Dies/Dies';
import DiesList from '@/models/Dies/DiesList';
import DiesFilter from '@/filters/Dies/DiesFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Uom from '@/models/Uom/Uom';
import UomFilter from '@/filters/Uom/UomFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
			uomId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
				uomId: { required : "Uom is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDies : null,
			currentDiesPage : 1,
			diesPageSize: 10,
			sortByDies: '',
			sortDescDies: '',
			uoms: [],
			uoms: [],
			isUomComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isUomComboLoading: false,
		}
	},
	methods : {
		getDies : async function(id) {
			this.isBusy = true;
			Dies.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDies = true;
			this.filterDies.id = this.modelId;
			Dies.downloadDataDetail(this, this.filterDies).then(result => {
				this.isDownloadDies = false;
			}).catch(error => { this.isDownloadDies = false; })
		},
		getDiess : async function(input) {
			let filter = new DiesFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isDiesComboLoading = true;
			Dies.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.diess = result.data
				}
				this.isDiesComboLoading = false;
			})
			.catch(error => {});
		},
		getUoms : async function(input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Uom.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.uoms = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedUom(item) {
			if(item == undefined || item == null) {
				this.model.uomId = null;
				this.model.uom = null;
			} else {
				this.model.uomId = item.id;
				this.model.uom = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.diesInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Dies.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'diesindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Dies.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'diesindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Dies.updateData(this, model, id)
					.catch((error) => {
						this.getDies(id);
					});
				}
			});
		},
		onHidden() {
			this.getDiess();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDies = new DiesFilter();
		//this.getUoms();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDies(id);
			} else {
				this.modelId = id;
				this.getDies(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
}
</script>
